import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';
import $ from 'jquery';
import { Button } from 'antd';
import AceEditor from 'react-ace';
import { DraggableModal, DraggableModalContext, DraggableModalProvider } from 'ant-design-draggable-modal';
import 'antd/dist/antd.css';
import 'ant-design-draggable-modal/dist/index.css';
import ModalsService from 'services/ModalsService';
import LoadingSpinner from 'components/core/LoadingSpinner';

const baseUrl = process.env.REACT_APP_BASE_URL; // this set via webpack build during transpile


export default class ImportDodForm extends React.Component {
    static propTypes = {
        processId: PropTypes.string,
        dod: PropTypes.string,
        runDate: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            existingVersions: null,
        };
    }

    componentDidMount() {
        if (!this.state.existingVersions) {
            this.fetchExistingVersions();
        }
    }

    fetchExistingVersions = () => {
        const runDate = this.props.runDate;
        const processName = this.props.processId;
        const dod = this.props.dod;

        const url = `${baseUrl}/dods/${dod}/versions`;
        const instance = this;
        $.ajax({
            url
        }).done((data, textStatus, jqXHR) => { // request was sucessful
            instance.setState({
                existingVersions: data
            });

        }).fail((jqXHR, textStatus, errorThrown) => {
            instance.setState({
                existingVersions: []
            });
        });
    };

    getNextMajorVersion = () => {
        let nextVersionNumber = '1.0';
        const versions = this.state.existingVersions;

        if (versions.length > 0) {
            const currentVersion = versions[versions.length - 1];
            const majorNumber = parseInt(currentVersion.split('.')[0], 10);
            const nextMajorNumber = majorNumber + 1;
            nextVersionNumber = `${nextMajorNumber}.0`;
        }
        return nextVersionNumber;
    };

    render() {
        if (!this.state.existingVersions) {
            return <LoadingSpinner/>;
        }

        return (
            <div>
                <p style={{ fontWeight: 'bold' }}>The following DOD will be created:</p>

                <p>{this.props.dod} v {this.getNextMajorVersion()}</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/forms/ImportDodForm.js